import { createSelector } from 'reselect';
import { OrderingSelectors } from 'polygon-ordering';
import getDisplayableSaleTypes from './getDisplayableSaleTypes';

const { getLocation } = OrderingSelectors;

export default createSelector([getDisplayableSaleTypes, getLocation], (saleTypes, location) => {
  return saleTypes.filter(saleType => location?.supportedSaleTypes.includes(saleType));
});
